module.exports = __webpack_public_path__ + "03_glasses_black.e4c25aa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer4/03_glasses_black.png
// module id = eCX9
// module chunks = 0